import React from 'react'

import PolicyIcon from '@mui/icons-material/Policy'

import { PolicyCardStyle } from '../styles'
import PolicyModal from '../modals/PolicyModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const PolicyCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={PolicyIcon}
            cardStyle={PolicyCardStyle}
            modal={<PolicyModal {...props} />}
            title={props.title}
            description={props.description}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default PolicyCard
